module.exports = __webpack_public_path__ + "static/desktop/img/paypal.fccd8d4e.png";